import React, { useEffect, useState } from 'react'
import { WImage } from '@next-nx/shared-ui/atoms'
import styles from './AppBox.module.sass'
import { AssistenzaButton } from '@next-nx/shared-ui/atoms'
import { MenuType } from '@next-nx/utils/types'
import { AppModal } from '@next-nx/shared-ui/organisms'
import { sendGTMData } from '../../../utils/gtm'
import { useIsMobile } from '@next-nx/hooks'


interface Props {
  item?: MenuType
  className?: string
  controlled?: boolean
  defaultAppModal?: MenuType|undefined
  setDefaultAppModal?: (m: MenuType|undefined) => void
  defaultOpenAppModal?: boolean
  setDefaultOpenAppModal?: (b: boolean) => void
}

const AppBox = (props: Props) => {

  const {
    item = undefined,
    className = '',
    controlled = false,
    defaultAppModal = null,
    setDefaultAppModal = () => {},
    defaultOpenAppModal = false,
    setDefaultOpenAppModal = () => {},
  } = props

  const isMobile = useIsMobile()
  const [appModalOpen, setAppModalOpen] = useState<boolean>(false)
  const [appModal, setAppModal] = useState<MenuType|undefined>(undefined)

  useEffect(() => {
    if(appModal){
      setAppModalOpen(true)
    }
    if(controlled && defaultAppModal) {
      setDefaultOpenAppModal(true)
    }
  }, [appModal, defaultAppModal])

  useEffect(() => {
    if(!appModalOpen) {
      setAppModal(undefined)
    }
    if(controlled && !defaultOpenAppModal) {
      setDefaultAppModal(undefined)
    }
  }, [appModalOpen, defaultOpenAppModal])

  return item ? (
    <div className={`${styles.appBox} ${className ? ` ${className}` : ''}`}>
      <div className={styles.imageBox}>
        <WImage
          maxWidth={400}
          maxHeight={480}
          src={isMobile ? item.mainImageResponsive : item.mainImage}
          className={styles.image}
          layout="intrinsic"
          objectFit="contain"
          key={`app-box-${item.pk}-main-image${isMobile ? '-mobile' : ''}`}
        />
      </div>
      <div className={styles.main}>
        <div className={styles.content}>
          <p className={styles.title}>{item.name}</p>
          {!!item.description && <div className={styles.description} dangerouslySetInnerHTML={{ __html: item.description }} />}
        </div>
        <div className={styles.list}>
          {item.children?.edges &&
            item.children.edges.map((child) => (
              <AssistenzaButton
                key={child.node.pk}
                label={child.node.description || ''}
                url={child.node.url}
                newPage={child.node.blank}
                onClick={() => {
                  setAppModal(child.node)
                  setDefaultAppModal(child.node)
                  sendGTMData({
                    event: "GAevent",
                    eventCategory: 'app',
                    eventAction: child.node.name?.toGTMFormat() || '',
                    eventLabel: 'download'
                  })
                }}
              />
          ))}
        </div>
      </div>
      {!controlled &&
      <AppModal
        app={appModal}
        open={appModalOpen}
        setOpen={setAppModalOpen}
      />
      }
    </div>
  ) : <></>
}

export default AppBox
